import { Component, OnInit, Input } from '@angular/core';

/**
 * Componente para generar chart lineal, ver guía de uso
 * @param: graphicData, configuración del chart
 */

 /*
  //https://www.fusioncharts.com/
  //Para hacer que funcione seguir la guía a continuación
  // Traigo la información de configuración
  let graphicData = gtp.getInfGraficoConfig();
  // Configuro el chart
  // Archivo a exportar
  graphicData.chart.exportFileName = "InformeSensorCombustible";
  // Valor mínimo del eje Y, sino se configura trae 0
  graphicData.chart.yAxisMinValue = velocidad.minima-2;
  // Valor Linea delta horizontal, para resaltar valores mayores a un limite
  graphicData.trendlines[0].line[0].startvalue = velocidad.limite;
  // Texto Linea delta horizontal, para resaltar valores mayores a un limite
  graphicData.trendlines[0].line[0].displayvalue = `${velocidad.limite} Km/h`;
  // Cargamos los valores del chart, considerar el que orden de la carga
  movildata.forEach((el, i) => {
      let grafico = new ControlVelocidadGrafico(el);
      //Se cargan las líneas de valores horizontales del gráfico
      graphicData.categories[0].category.push({ label: `${grafico.fecha}<br />${grafico.hora}` });
      //Se cargan los puntos a mostrar en el gráfico
      graphicData.dataset[0].data.push(grafico.punto);
  });
*/

@Component({
  selector: 'chart-linechart',
  templateUrl: './linechart.component.html',
  styleUrls: ['./linechart.component.scss']
})
export class LineChartComponent implements OnInit {

  @Input() graphicData: any;

  constructor(
  ) {
    
  }

  ngOnInit() {
    
  }
  
}
